import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

const savedLanguage: string = localStorage.getItem("language") || "en"; 
const PUBLIC_URL = import.meta.env.VITE_PUBLIC_URL || "";  // Fallback for dev mode

i18n
    .use(HttpBackend) // Load translations from external files
    .use(LanguageDetector) // Detect user language
    .use(initReactI18next) // Pass i18n instance to react-i18next
    .init({
        fallbackLng: "en", // Default language
        supportedLngs: ["en", "de", "pl","ro"], // Define available languages
        nonExplicitSupportedLngs: true,
        debug: true, // Enable debug mode
        lng: savedLanguage,
        backend: {
            loadPath: `${PUBLIC_URL}/locales/{{lng}}/translation.json`,
        },
        interpolation: {
            escapeValue: false, // React already protects against XSS
        },
    });

export default i18n; // 

